import { useForm } from "react-hook-form";
import { withRouter } from "react-router-dom";
import { Loader } from "semantic-ui-react";
import { regexEmail } from "../../../utils/Regex";
import FormError from "../../Errors/FormError";
import PlaceHolder from "../../util/PlaceHolder";
import validator from "validator";

const HomePage = ({ onEmailSubmit, onSignIn, ...rest }) => {
  const { handleSubmit, errors, register, clearErrors } = useForm();
  const toTermsOfUse = () => {
    // don't want to disturb styles by adding NavLink
    window.open("/developer-tos", "_blank");
  };

  return (
    <>
      <div className="container body-margin-top">
        <div className="row">
          <div className=" col-md-5 " style={{ minHeight: "566px" }}>
            <div class="row vi-yl-card">
              <div class="col-md-12">
                <form
                  className="signup-form"
                  onSubmit={handleSubmit(onEmailSubmit)}
                >
                  <div className="head">
                    <p>Let’s get started!</p>
                    <h2>Create your free account.</h2>
                  </div>
                  <div className="input-group">
                    <div className="signup-email">
                      <label htmlFor>
                        <i
                          className="fa fa-envelope font-size-18"
                          aria-hidden="true"
                        />
                        Email ID<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        autoComplete="new-password"
                        ref={register({ required: true, pattern: regexEmail })}
                        name={"user_email"}
                        type="email"
                        className="form-control"
                        placeholder="Enter your email address"
                        id="user-signup-email"
                      />
                      {rest.errorMessage && (
                        <div style={{ color: "#EE2737", marginTop: "55px" }}>
                          <FormError errorMessage="A user with this email address already exists" />
                        </div>
                      )}

                      {errors.user_email &&
                        !rest.errorMessage &&
                        errors.user_email.type === "required" && (
                          <div style={{ color: "#EE2737", marginTop: "55px" }}>
                            <FormError errorMessage="Email is required" />
                          </div>
                        )}

                      {errors.user_email &&
                        !rest.errorMessage &&
                        errors.user_email.type === "pattern" && (
                          <div style={{ color: "#EE2737", marginTop: "55px" }}>
                            <FormError errorMessage="Invalid Email" />
                          </div>
                        )}
                      {/* <div id="errorMsg" className="error-highlight margin-top-10">Please enter a valid Email ID</div> */}
                    </div>
                    <div className="info form-info">
                      <p>
                        <i
                          className="fa fa-exclamation-circle font-size-20"
                          aria-hidden="true"
                        />
                        Your email id will be used as User ID for login. Kindly
                        use your official email id only.
                      </p>
                    </div>
                    <div className="accept-terms">
                      <input
                        defaultChecked
                        ref={register({ required: true })}
                        name={"tc_checkbox"}
                        type="checkbox"
                        style={{ cursor: "pointer" }}
                      />
                      <span className="form-info" style={{ cursor: "allowed" }}>
                        I accept the{" "}
                        <a onClick={toTermsOfUse} style={{ cursor: "pointer" }}>
                          Terms and Conditions
                        </a>
                        .
                      </span>
                      {errors.tc_checkbox &&
                        errors.tc_checkbox.type === "required" && (
                          <div style={{ color: "#EE2737", marginTop: "5px" }}>
                            <FormError errorMessage="Please accept Terms and Conditions" />
                          </div>
                        )}
                    </div>
                    <div className="input-group-append">
                      <button type="reset" className=" sec-btn ">
                        reset
                      </button>{" "}
                      &nbsp;{" "}
                      <button
                        type="submit"
                        className=" pri-btn"
                        style={{ border: "none" }}
                      >
                        sign up
                        <span hidden={!rest.isLoading}>&nbsp;</span>
                        <Loader
                          inverted
                          active={rest.isLoading}
                          inline
                          size="tiny"
                        />
                      </button>
                      <p className="form-ft-link">
                        Already have an account?{" "}
                        <a
                          onClick={onSignIn}
                          style={{ cursor: "pointer" }}
                          className="link-crimson"
                        >
                          sign in
                        </a>
                      </p>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
  

};
export default withRouter(HomePage);
